import {
	UserActionTypes,
	SET_USER,
} from "store/actions/user-actions/user-action-types";
import { AccountProps, UserType } from "lib/types";

export const setUserAction = (user: UserType, account: AccountProps ): UserActionTypes => {
	return { type: SET_USER, payload: { user, account } };
};